<template>
  <div ref="tooltip" class="tooltip" :class="{
      'tooltip--visible': visible,
      'tooltip--shallow-margin': shallowMargin,
      'tooltip--no-margin': noMargin
    }">
    <div class="tooltip__content">
      <slot>
        <span class="tooltip__text">{{ content }}</span>
      </slot>
    </div>
  </div>
</template>

<script>
import Popper from 'popper.js'

export default {
  props: {
    'target': {
      type: String,
      required: true
    },
    'content': {
      type: String
    },
    'position': {
      type: String,
      default: 'top'
    },
    'delay': {
      type: [Object, Array, Number],
      default: 500
    },
    'shallow-margin': {
      type: Boolean,
      default: false
    },
    'no-margin': {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      targetElement: null,
      popperInstance: null,
      timeoutId: null,
      visible: false
    }
  },

  methods: {
    initPopper() {
      this.popperInstance = new Popper(this.targetElement, this.$refs.tooltip, {
        placement: this.position,
        eventsEnabled: false
      });
    },
    getEnterDelay() {
      if (this.delay instanceof Array) {
        return this.delay[0] ? this.delay[0] : 0;
      }

      if (this.delay instanceof Object) {
        return this.delay.enter ? this.delay.enter : 0;
      }

      return this.delay;
    },
    getLeaveDelay() {
      if (this.delay instanceof Array) {
        return this.delay[1] ? this.delay[1] : 0;
      }

      if (this.delay instanceof Object) {
        return this.delay.leave ? this.delay.leave : 0;
      }

      return 0;
    },
    showTooltip() {
      this.visible = true;
    },
    hideTooltip() {
      this.visible = false;
    },
    prepareToShowTooltip() {
      let vm = this;

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }

      this.timeoutId = setTimeout(() => {
        vm.showTooltip();
        clearTimeout(vm.timeoutId);
      }, this.getEnterDelay())
    },
    prepareToHideTooltip() {
      let vm = this;

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }

      this.timeoutId = setTimeout(() => {
        vm.hideTooltip();
        clearTimeout(vm.timeoutId);
      }, this.getLeaveDelay())
    }
  },

  mounted() {
    let vm = this;
    this.targetElement = this.$parent.$refs[this.target];

    this.initPopper();
    this.targetElement.addEventListener('mouseenter', vm.prepareToShowTooltip);
    this.targetElement.addEventListener('mouseleave', vm.prepareToHideTooltip);
  },

  destroyed() {
    let vm = this;
    // Remove the event listener when the instance is destroyed so that we cleanup the browser.
    this.targetElement.removeEventListener('mouseenter', vm.prepareToShowTooltip);
    this.targetElement.removeEventListener('mouseleave', vm.prepareToHideTooltip);

    if (this.popperInstance) {
      this.popperInstance.destroy();
      this.popperInstance = null;
    }
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
.tooltip {
  z-index: 10;
  background-color: $color-dark-2;
  padding: em(10px);
  margin: em(10px);
  box-shadow: $box-shadow--standard;
  border-radius: em(2px);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: visibility 0s 0.5s, opacity 0.5s ease;
  // white-space: nowrap; // Use this to keep the text on one line.
}

.tooltip--shallow-margin {
  margin: em(5px);
}

.tooltip--no-margin {
  margin: 0;
}

.tooltip--visible {
  opacity: 1;
  visibility: visible;
  transition: opacity 0.5s ease;
}

.tooltip__content {
  text-align: center;
  // white-space: nowrap; // Use this to keep the text on one line.
}

.tooltip__text {
  color: rgba(255, 255, 255, 0.7);
  font-size: em(14px);
}
</style>